/* eslint-disable no-return-assign */
/* eslint-disable @typescript-eslint/no-misused-promises */
import { Flex, Text } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { FaFileCsv } from 'react-icons/fa'
import { IAssessmentCamposModel } from '../..'
// import { useNavigate } from 'react-router'

import { ButtonCmp } from '../../../../../../components/ButtonCmp'

import { ModalBase } from '../../../../../../components/ModalBase'

import { SearchCmp } from '../../../../../../components/SearchCmp'
import { appApi } from '../../../../../../services/appApi'
// import { appApi } from '../../../../../../services/appApi'

interface iModalProps {
  isOpen: boolean
  assessments: IAssessmentCamposModel
  titulo: string
  filtro: number
  onRequestClose: () => void
  // onChangeStatus: (id: string, status: string) => void
  // baixarRelatorio: (e: itemGestao, urlpdfRelatorioIndividual: string, tipo: string) => void
  IsLoading?: string
}
export function compararRespostas(valor: string, outro: string[]): boolean {
  return outro.includes(valor)
}
export function contarAlteracoes(primeiraLista: string[], segundaLista: string[]): number {
  return primeiraLista.filter(item => !segundaLista.includes(item)).length
}
export const ModalAnalise: React.FC<iModalProps> = ({ filtro, isOpen, onRequestClose, IsLoading, titulo, assessments }) => {
  // const nav = useNavigate()
  const [SearchText, setSearchText] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    setIsLoading(false)
  }, [isLoading])

  function onGetCsv(): void {
    setIsLoading(true)

    appApi.post(`api/SIDashboardIA/ObterCsv?filtro=${filtro}`, { campo: assessments.campo }, { responseType: 'blob' })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `ListaCamposAlterados_${assessments.campo}_${new Date().toLocaleDateString('pt-BR')}_${new Date().toLocaleTimeString('pt-BR')}.csv`)
        document.body.appendChild(link)
        link.click()
        link.remove()
        setIsLoading(false)
      })
      .catch((err) => {
        console.log(err)
        setIsLoading(false)
      })
  }

  return (
    <ModalBase
      isOpen={isOpen}
      onClose={onRequestClose}
      Width='72rem'
    >
      <Flex flexDir={'column'} padding={'0 .5rem 1rem .5rem'}>
        <Flex justifyContent={'space-between'} margin='1.75rem 0rem'>
          <Flex direction={'column'} justifyContent={'start'}>
            <Text fontSize={'24px'}>{titulo} - <strong>{assessments.campo}</strong></Text>

          </Flex>
          <Flex gap={'1rem'} justifyContent={'end'}>
            <ButtonCmp isLoading={isLoading} leftIcon={<FaFileCsv/>} VarColor='Green2' onClick={() => onGetCsv()}>Baixar CSV</ButtonCmp>
            <SearchCmp
              EnterAction={() => { }}
               OnChange={setSearchText}
              placeholder={'Buscar'}
            />
          </Flex>
        </Flex>
        <Flex direction="column" maxW="72rem" border="1px solid var(--c5)">

          {/* Cabeçalho */}
          <Flex bg="var(--c2)" py=".75rem" px="1.5rem" fontWeight="bold" fontSize="14px" borderBottom="1px solid var(--c5)">
            <Flex flex="2">{assessments.assessments.length} Assessments com alterações no campo&nbsp;<strong>{assessments.campo}</strong></Flex>
          </Flex>

          {/* Corpo */}
          <Flex direction="column" maxH="85vh" overflowY="auto">
          {assessments.assessments.filter(a => {
            return SearchText === '' || a.nome.toLowerCase()
              .includes(SearchText.toLowerCase())
          })
            .map(a =>
          <Flex direction={'column'} bg="var(--c1)" py="1.75rem" px="0.5rem" fontWeight="bold" fontSize="14px" borderBottom="1px solid var(--c5)">
            <Flex justifyContent={'space-between'} px='2rem' py='.5rem'
            borderTop="1px solid var(--c5)"
            borderBottom="1px solid var(--c5)">
            <Flex flex="2">Candidato: {a.nome}</Flex>
            <Flex flex="1" justify="end">Data de criação: {a.data}</Flex>
            </Flex>

            <Flex my='2rem' justifyContent={'space-around'}>
            {a.campoAlterado.length === 1 ? <Flex justify="center">{assessments.campo} entregue: </Flex> : <Flex justify="center">Entregue ({contarAlteracoes(a.campoAlterado, a.campoOriginal)} alterações)</Flex>}
            {/* <Flex justify="center">Entregue: {a.campoAlterado.length} </Flex> */}
            {a.campoOriginal.length === 1 ? <Flex justify="center">{assessments.campo} Original: </Flex> : <Flex justify="center">Processamento Original ({contarAlteracoes(a.campoOriginal, a.campoAlterado)} alterações) </Flex>}
            {/* <Flex justify="center">Processamento Original: {a.campoOriginal.length} </Flex> */}
            </Flex>
            <Flex width="100%" gap={'.5rem'} >
              <Flex flex={'1'}
               direction={'column'} gap={'1rem'}

>
              {a.campoAlterado.map((c) =>
                <Flex
                justify={c.length === 1 ? 'center' : 'start'}
                p={'0.5rem'}
                bgColor={(compararRespostas(c, a.campoOriginal) ? 'gray.100' : 'blue.200')}
                textColor={(compararRespostas(c, a.campoOriginal) ? 'gray.800' : 'blue.800')}
                fontWeight={(compararRespostas(c, a.campoOriginal) ? 'normal' : 'bold')}

                >{c}</Flex>
              )}
              </Flex>

              <Flex
              direction={'column'} gap={'1rem'}
              flex={'1'}
              >
              {a.campoOriginal.map((c) =>
                <Flex
                justify={c.length === 1 ? 'center' : 'start'}
                p={'0.5rem'}
                bgColor={(compararRespostas(c, a.campoAlterado) ? 'gray.100' : 'red.100')}
                textColor={(compararRespostas(c, a.campoAlterado) ? 'gray.800' : 'red.700')}
                fontWeight={(compararRespostas(c, a.campoAlterado) ? 'normal' : 'bold')}
                >{c}</Flex>
              )}
              </Flex>
            </Flex>

          </Flex>)}
          </Flex>
                </Flex>
                </Flex>

    </ModalBase>
  )
}
